import { useMemo } from 'react'
import { useResponsiveTier } from '@renderer/hooks/useResponsiveTier'
import type { ResponsiveTier } from '@renderer/utils/responsiveTier'

/**
 * Layout metrics from the physical viewport (session pages are fully responsive).
 * Compact/tiny follow `useResponsiveTier` (single tier system under View).
 */
export function useDesignLayout(): {
  designW: number
  designH: number
  isPortrait: boolean
  isLandscape: boolean
  isCompact: boolean
  isTiny: boolean
  isSpacious: boolean
  shortSide: number
  tier: ResponsiveTier
} {
  const rt = useResponsiveTier()

  return useMemo(() => {
    const shortSide = Math.min(rt.viewportWidth, rt.viewportHeight)
    return {
      designW: rt.viewportWidth,
      designH: rt.viewportHeight,
      isPortrait: rt.isPortraitViewport,
      isLandscape: rt.isLandscapeViewport,
      isCompact: rt.isCompact,
      isTiny: rt.isTiny,
      isSpacious: rt.tier === 'spacious',
      shortSide,
      tier: rt.tier
    }
  }, [rt])
}
